<template>
    <div class="bottomleft_wrap">
        <div class="bottomleft_wrap_title">工单概览</div>
        <div style="height: calc(100% - 50px);">
        <el-table class="top-default-margin" size="mini" :data="listData"  highlight-current-row v-loading="loading" max-height="340px" stripe element-loading-text="拼命加载中"
        :header-cell-style="{ background:'#087490',height:'24px',color:'#09dfe0',border: '1px solid #086d7f'}"
        :cell-style="{background:'#0a193d',color:'#fff',borderBottom: '1px solid #086d7f'}"
        style="width: 100%;">
            <el-table-column sortable prop="orderCode" label="工单编号" width="120">
            </el-table-column>
            <el-table-column prop="status" label="状态" width="90">
             <template slot-scope="scope">
              <el-tag :type="changeStatusColor(scope.row.orderStatus)" size="small">{{scope.row.orderStatus}}</el-tag>
                  <!-- <el-tag v-for="(item,index) in scope.row.status" :type="changeStatusColor(item)" :key="item" style="height:28px;" :style="{'marginBottom':(index!=scope.row.status.length-1)?'8px':'0'}">{{item}}</el-tag> -->
              </template>
            <!-- <template slot-scope="scope">
                <el-tooltip :content="scope.row.status" placement="top">
                    <span class="small-cilcle" :class="changeClass(scope.row)"></span>
                    <span class="txt-overflow">{{scope.row.status}}</span>
                </el-tooltip>
              </template> -->
          </el-table-column>
            <el-table-column  prop="produceTasks" label="生产进度" min-width="400" class-name="table-cell-self">
              <template slot-scope="scope">
                <div class="list-line-box">
                <div class="default-process-item" v-for="(item,index) in scope.row.produceTasks" :key="item.label">
                  <el-tooltip class="item" effect="dark" placement="right">
                      <div slot="content">
                        <div class="tootip-content">
                          <div style="font-size:14px;font-weight:bold;" class="bottom-small-margin content">{{item.processName}}</div>
                          <div>工序进度：{{item.goodNum?item.goodNum:0}}/{{item.planNum?item.planNum:0}}</div>
                          <el-divider class="small-row-margin"></el-divider>
                          <div class="content">工序计划数：{{item.planNum}}</div>
                          <div class="content">已报工良品数：{{item.goodNum}}</div>
                          <div>已报工不良品数：{{item.nongoodNum}}</div>
                          <el-divider class="small-row-margin"></el-divider>
                          <div class="content">已审批良品数：{{item.approvedGoodNum}}</div>
                          <div>未审批良品数：{{item.unapprovedGoodNum}}</div>
                          <el-divider class="small-row-margin"></el-divider>
                          <div class="bottom-mini-margin content">最近报工时间：{{item.updateTime}}</div>
                        </div>
                      </div>
                      <div>
                        <div style="display: flex; align-items: center;">
                          <div class="default-circle" :class="{'blue-circle':(item.process > 0 && item.process < 100) ,'green-circle':item.process >= 100}">
                            <div class="delay-tag default-delay-tag" v-if="item.exceed">逾</div>
                            <span class="default-percent-text" v-if="item.process < 100">{{item.process}}%</span>
                            <i class="el-icon-check" v-if="item.process >= 100"></i>
                          </div>
                          <span style="position: absolute;left: 48px;color: #bbb;" v-if="index!=(scope.row.produceTasks.length-1)">——</span>
                        </div>
                        <div class="process-text default-process-text">{{item.processName}}</div>
                      </div>
                  </el-tooltip>
                </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column  prop="productCode" label="产品编号">
              <template slot-scope="scope">
                <div>{{scope.row.productCode}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="productName" label="产品名称">
              <template slot-scope="scope">
                <div>{{scope.row.productName}}</div>
              </template>
            </el-table-column>
            <el-table-column  prop="specs" label="产品规格">
              <template slot-scope="scope">
                <div>{{ scope.row.specs}}</div>
              </template>
            </el-table-column>
            <el-table-column  prop="planNum" label="计划数"></el-table-column>
            <!-- <el-table-column  prop="editUser" label="实际数"></el-table-column> -->
        </el-table>
    </div>
    </div>

</template>

<script>
import { orderGetList} from '@/api/basicData'
export default {
    data() {
        return {
            // listData:[{
            //     deptName:'111',
            //     status:['执行中','逾'],
            //     workOrderType:'正常排产',
            //     progress:[{label:'车轮组装',value:0,exceed:false},{label:'车架组装',value:0,exceed:false},{label:'整车调试',value:0,exceed:false}]
            // },{
            //     deptName:'111',
            //     status:['执行中','逾'],
            //     progress:[{label:'车轮组装',value:50,exceed:true},{label:'车轮调试',value:0,exceed:true},{label:'车架组装',value:0,exceed:true},{label:'整车调试',value:0,exceed:true}]
            // },{
            //     deptName:'111',
            //     status:['未开始','逾'],
            //     progress:[{label:'开料',value:100,exceed:true},{label:'粗车加工',value:0,exceed:true},{label:'滚齿',value:0,exceed:true},{label:'去毛刺',value:0,exceed:true},{label:'电镀',value:0,exceed:true},{label:'包装',value:0,exceed:true}]
            // }],
            drawer: false,
            innerDrawer: false,
            loading:false,
            color:['#333333','#02B980','#1990FF','#FBB832','#FE5950'],
            userData:JSON.parse(window.localStorage.getItem('userdata')),
            // 分页参数
            pageparm: {
              currentPage: 1,
              pageSize: 10,
              total: 10
            },
            listData:[],
            // tagType:[ { type: '', label: '全部',value:12 },
            // { type: 'success', label: '未开始',value:12 },
            // { type: 'info', label: '执行中' ,value:12},
            // { type: 'danger', label: '已结束' ,value:12},
            // { type: 'warning', label: '已取消' ,value:12}],
        }
    },
    created(){
      this.getdata()
    },
    mounted() {
    },
    methods: {
       // 查询工单进度报表
    getdata() {
      this.loading = true
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
          orderStatus:this.orderStayus
        },
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      orderGetList(params).then(res => {
        if(res.code == 200){
          this.pageparm.total = res.data.total
          this.listData = res.data.list
          this.listData.map(function(item){
            //item.progress = []
            if(item.produceTasks){

              item.produceTasks.map(function(item1){
                var tem = item1
                if(item1.goodNum == '-'){
                  item1.goodNum = 0
                }
                if(item1.planNum == '-'){
                  item1.planNum = 0
                }
                if(item1.nongoodNum == '-'){
                  item1.nongoodNum = 0
                }
                if(item1.goodNum && item1.planNum){
                  //tem.process = item1.goodNum/item1.planNum
                  item1.process = ((item1.goodNum/item1.planNum) * 100).toFixed(2);
                }else{
                  tem.process = 0
                }
                //item.progress.push(tem)
              })
            }
          })
        }else{
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    changeStatusColor(options){
        if(options == '逾'){
            return 'danger'
        }else if(options == '执行中'){
            return 'success'
        }{
            return ''
        }
    },
    }
}
</script>

<style scoped>
.bottomleft_wrap{
    width: 100%;
    height: 100%;
    padding: 1.5%;
    color: #fff;
    font-size: 12px;
    box-sizing: border-box;
}
.bottomleft_wrap_title {
    color: #04f9fe;
    font-size: 16px;
    margin-top: 5px;
    margin-bottom: 10px;
    margin-left: 10px;
    padding-bottom: 5px;
    font-weight: 600;
}
.el-icon-plus:hover{
  color: #1890ff;
}
.order-main{
  position: relative;
}
.add-button{
  position: absolute;
  top: 55px;
  right: 16px;
  padding: 4px;
}
.bottom-default-margin{
  margin-bottom: 15px;
}
.el-icon-s-order{
  font-size: 16px;
}
.tag-item{
  display: inline-block;
  height: 32px;
  padding: 0 12px;
  line-height: 30px;
  font-size: 12px;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  cursor: pointer;
  background-color: #f1f8f8;
  color: #909399;
  margin-right: 15px;
  color: #666;

}
.tag-item:hover{
  background-color: #f0f2f6;
}
.tag-item-active{
  color: #409eff;
  background-color: #ecf5ff;
}
.el-select .el-input {
  width: 130px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.el-input-group__append .el-button--primary,
.el-input-group__prepend .el-button--primary{
  color: #fff;
  background-color: #1890ff;
  border-radius: 0 4px 4px 0;
}
.default-circle{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid rgb(204, 204, 204);
  }
  .blue-circle{
  border: 3px solid rgb(0, 120, 231);
  }
  .green-circle{
    color: #02b980;
    font-size: 35px;
    font-size: 21px;
    border: 3px solid rgb(2, 185, 128);
  }
  .default-percent-text{
    font-weight: 600;
    font-size: 10px;
    white-space: nowrap;
    vertical-align: middle;
    transform: scale(.83);
  }

  .default-process-item {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    width: 36px;
    margin-right: 50px;
    margin-bottom: 20px;
}
.table-cell-self .cell{
  padding-left: 0px!important;
  padding-right: 0px!important;
}
.list-line-box {
    display: flex;
    align-items: center;
    width: 100%;
    /* padding: 0 8px; */
    overflow-y: hidden;
    transform: scale(0.6);
    margin-top: -12px;
}
.default-process-text {
    position: absolute;
    left: 18px;
    max-width: 72px;
    margin-top: 2px;
    font-size: 12px;
    line-height: 12px;
    transform: translateX(-50%);
    bottom: -18px;
}
.process-text {
    max-width: 50px;
    overflow: hidden;
    color: #fff;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.default-delay-tag {
    position: absolute;
}
.delay-tag {
  top: -5px;
  right: -7px;
  margin-right: 2px;
  color: #fff;
  font-size: 10px;
  background-color: #ff393d;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  -webkit-transform: scale(.83);
  transform: scale(.83);
}
.tootip-content .content{
  height: 24px;
}
.el-divider{
  background-color: #575859;
}


.bottomleft_wrap >>> .el-tag{
    background: transparent;
 }
 .bottomleft_wrap >>> .el-table .cell{
  height: 32px!important;
  line-height: 32px!important;
  padding-left: 0px!important;
  padding-right: 0px!important;
 }
</style>



// WEBPACK FOOTER //
// src/views/workshopSignage/workshopSignage/components/bottomleft.vue